// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkout_root__Ur5SX","lightBlue":"Checkout_lightBlue__1Hg-L","link":"Checkout_link__2UlKj"};